export const MIN_PASSPHRASE = 10;

export function passphraseProblem(p: string): string | null {
  if (p.trim().length < MIN_PASSPHRASE) return `passphrase는 ${MIN_PASSPHRASE}자 이상이어야 합니다.`;
  return null;
}

export function PassphraseHint({ value }: { value: string }) {
  const ok = !passphraseProblem(value);
  return (
    <p className={ok ? 'muted small' : 'small warn'}>
      {MIN_PASSPHRASE}자 이상. 여러 단어를 이어 쓴 문장형을 권장합니다 (예: 기억하기 쉬운 짧은 문장).
    </p>
  );
}
